import { convertTimeStampToFormattedDate } from "components/Onboarding/Mle/mle.utils";

function BulkUploadIdList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

BulkUploadIdList.prototype = Object.assign(BulkUploadIdList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.bulkPaylinkFileProcessDto &&
            tableData.bulkPaylinkFileProcessDto.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            requestId,
            requestPurpose,
            merchantId,
            validCount,
            invalidCount,
            status,
            createdDate
        } = row;
        return {
            requestId,
            requestPurpose : requestPurpose && requestPurpose.replace('BULK_TERMINAL_UPLOAD','Bulk Terminal Creation'),
            merchantId,
            validCount,
            invalidCount,
            status,
            totalCount: Number(validCount) + Number(invalidCount),
            createdDate: convertTimeStampToFormattedDate(createdDate)
        };
    },
});

export default BulkUploadIdList;
